<template>
    <div class="Vheader page-header">
        <div v-if="page"
            class="Vheader__title"
        >
            {{page}}
        </div>
 
  <span class="Vheader-left">
     <slot name="left"></slot>
  </span>
        <span class="Vheader-right">
     <slot name="right"></slot>
  </span>
        <div
            class="profile-menu"
        >
            <img
                class="logout"
                src="/icons/app/icon_exit.svg"
                alt="Exit"
                @click="logout"
            >
            <div
                class="dropdown"
            >
                <div class="email">{{ user.email }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import AWS from '@/resources/AWS.js';
    import {getUser} from '@/api/apiServices';
    
    export default {
        name: 'VHeader',
        data() {
            return {
                user: getUser(),
            };
        },
        props: {
            page: {
                type: String,
                default: '',
            },
        },
        methods: {
            logout() {
                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                if (params.staging) {
                    localStorage.setItem('lastPageIsStage', params.staging);
                }
                AWS.logout();
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .Vheader {
        display: flex;
        align-items: center;
        height: 40px;
        background: $light-blue-color;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 100%;
        &__title{
            cursor: pointer;
            padding-left: 31px;
            color: $dark-blue-color;
            text-align: left;
            width: 100%;
            font-size: 15px;
            line-height: 20px;
            font-weight: 700;
        }
        
        &-left {
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin-left: 1px;
        }
        
        &-right {
            display: flex;
            justify-content: space-around;
        }
        
        
        .profile-menu {
            display: flex;
            flex-direction: column;
            margin: 8px;
            position: absolute;
            width: 30px;
            right: 1px;
            top: 0;
            justify-content: center;
            align-items: center;
            
            .dropdown {
                right: -11px;
                top: 30px;
                display: none;
                position: absolute;
                background: white;
                width: 200px;
                z-index: 999;
                padding-bottom: 2px;
                padding-left: 10px;
                padding-right: 10px;
                @include default-shadow;
                
                .email {
                    padding-top: 10px;
                    padding-bottom: 10px;
                }
                
            }
            
            .logout {
                cursor: pointer;
                width: 21px;
                height: 100%;
                padding-bottom: 10px;
            }
            
            &:hover {
                .dropdown {
                    display: block;
                }
            }
            
        }
        
    }
</style>